import { ColumnFilter } from "../domainObjects/columnFilter";
import { PreviewDataOptions } from "../domainObjects/previewDataOptions";
import { CacheKeyType } from "../domainObjects/transformType";
import { ColumnFilterInfo } from "../views/previewTable/filterUI/column-filter/column-filter.component";

export class GetSummaryDataFarmPreviewRequest {
    userId: string;
    orgId: string;
    refineryId: string;
    nodeId: string;
    transformId: string;
    cacheKeyType:CacheKeyType;
    previewOptions: PreviewDataOptions;
    selectedColNames: string;
    isNewCache:boolean=false;
    parentFilters?: ColumnFilter[];
    summaryType:SummaryType=SummaryType.DataFarm;
    constructor(
        userId: string,
        orgId: string,
        refineryId: string,
        nodeId: string,
        transformId: string,
        cacheKeyType:CacheKeyType,
        previewOptions: PreviewDataOptions,
        selectedColNames: string,
        isNewCache:boolean=false,
        summaryType:SummaryType=SummaryType.DataFarm,
        parentFilters?: ColumnFilter[]
    ) {

        this.userId = userId;
        this.orgId = orgId;
        this.refineryId = refineryId;
        this.nodeId = nodeId;
        this.transformId = transformId;
        this.cacheKeyType = cacheKeyType;
        this.previewOptions = previewOptions;
        this.selectedColNames = selectedColNames;
        this.isNewCache=isNewCache;
        this.summaryType=summaryType;
        this.parentFilters=parentFilters;
    }
}

export interface GetSummaryEmptyColslistResponse {
    blanks_cols_list: string[];
}

export enum SummaryType {
    DataFarm = 1,
    Result = 2
}